import _extends from "@babel/runtime/helpers/extends";
import LockIcon from '@atlaskit/icon/glyph/lock';
import { extractProvider } from '@atlaskit/link-extractors';
import { R300 } from '@atlaskit/theme/colors';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { messages } from '../../../../messages';
import Text from '../../../FlexibleCard/components/elements/text';
import UnresolvedView from './unresolved-view';
import { withFlexibleUIBlockCardStyle } from './utils/withFlexibleUIBlockCardStyle';

/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */
const FlexibleNotFoundView = ({
  testId = 'smart-block-not-found-view',
  ...props
}) => {
  var _cardState$details2;
  const intl = useIntl();
  const {
    cardState
  } = props;
  const product = useMemo(() => {
    var _cardState$details, _provider$text;
    const provider = extractProvider(cardState === null || cardState === void 0 ? void 0 : (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data);
    return (_provider$text = provider === null || provider === void 0 ? void 0 : provider.text) !== null && _provider$text !== void 0 ? _provider$text : '';
  }, [cardState === null || cardState === void 0 ? void 0 : (_cardState$details2 = cardState.details) === null || _cardState$details2 === void 0 ? void 0 : _cardState$details2.data]);
  const title = useMemo(() => intl.formatMessage(messages.not_found_title, {
    product
  }), [intl, product]);
  const description = useMemo(() => ({
    descriptor: messages.not_found_description
  }), []);
  return /*#__PURE__*/React.createElement(UnresolvedView, _extends({}, props, {
    testId: testId,
    title: title
  }), /*#__PURE__*/React.createElement(LockIcon, {
    label: "not-found-lock-icon",
    size: "small",
    primaryColor: `var(--ds-icon-danger, ${R300})`,
    testId: `${testId}-lock-icon`
  }), /*#__PURE__*/React.createElement(Text, {
    message: description,
    testId: `${testId}-message`,
    maxLines: 3
  }));
};
export default withFlexibleUIBlockCardStyle(FlexibleNotFoundView);